var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBikkuri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_89_6",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 89 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1516",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1516",
    transform: "translate(-228 -1880)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_13350",
    "data-name": "\\u9577\\u65B9\\u5F62 13350",
    transform: "translate(228 1880)",
    fill: "#f25151",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1518",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1518",
    transform: "translate(98.822 1556.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_225",
    "data-name": "\\u30D1\\u30B9 225",
    d: "M145.178,327.928a11.827,11.827,0,1,1-11.827,11.828,11.841,11.841,0,0,1,11.827-11.828m0-4.173a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z",
    fill: "#f25151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_226",
    "data-name": "\\u30D1\\u30B9 226",
    d: "M146.808,343.306l.586-11.361h-3.962l.527,11.361Z",
    transform: "translate(-0.235 -0.182)",
    fill: "#f25151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_227",
    "data-name": "\\u30D1\\u30B9 227",
    d: "M145.355,344.679a1.678,1.678,0,1,0,1.672,1.683v-.011A1.674,1.674,0,0,0,145.355,344.679Z",
    transform: "translate(-0.234 -0.337)",
    fill: "#f25151"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikkuri);
export default __webpack_public_path__ + "static/media/bikkuri.3515330e94adcb836ddc62537010983b.svg";
export { ForwardRef as ReactComponent };